var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden","position":"relative"}},[_c('div',{ref:"mapbox",staticStyle:{"width":"100%","height":"100%"}}),_c('infowindow',{ref:"infowindow",attrs:{"viewer":_vm.map}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }